import React from "react";
import {BundleOption} from "../../../../../interfaces/ecom/schema";
import {BundleItem} from "./BundleItem";
import {BundleSummary} from "./BundleSummary/BundleSummary";

interface BundleProps {
    Option: BundleOption;
}

export const Bundle: React.FC<BundleProps> = ({Option}) => {
    return (
        <div className={"pdp-bundle"} key={Option.BundleId}>
            <div className="pdp__badges-container">
                <span className={"pdp-bundle__label pdp-badge pdp-badge--red"}>{Option.BundleName}</span>
            </div>
            <div className={"pdp-bundle__items"}>
                {Option.Items.map((item, itemIndex) => <BundleItem item={item} itemIndex={itemIndex}/>)}
            </div>
            <BundleSummary BundleId={Option.BundleId} UnitPrice={Option.UnitPrice}
                           PromotionUnitPrice={Option.PromotionUnitPrice}/>
        </div>
    );
}
